import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import Loading from 'Components/Loading';
import styles from './PaymentLoading.scss';

const PaymentLoading = ({ waitingForAuthToken }) => {
  const messages = [
    'This may take up to a minute. Please do not refresh your browser.',
    'Hang tight! We’re almost done.',
    'Hang tight! We’re almost done (really).',
    'Payment received! Logging you in (which might take a minute)',
  ];
  const [messageId, setMessageId] = useState(0);
  const prevAuthTokenRef = useRef();

  useEffect(() => {
    let messageTimout;
    if (messageId === 0) {
      messageTimout = window.setTimeout(() => setMessageId(1), 7500);
    }
    if (messageId === 1) {
      messageTimout = window.setTimeout(() => setMessageId(2), 7500);
    }

    if (waitingForAuthToken && !prevAuthTokenRef.current) {
      setMessageId(3);
      clearTimeout(messageTimout);
    }

    prevAuthTokenRef.current = waitingForAuthToken;

    return function cleanup() {
      clearTimeout(messageTimout);
    };
  });

  return (
    <div className="PaymentLoading">
      <Loading
        type="payment"
        header="Processing your payment"
        description={messages[messageId]}
      />
    </div>
  );
};

PaymentLoading.propTypes = {
  waitingForAuthToken: PropTypes.bool,
};

PaymentLoading.defaultProps = {
  waitingForAuthToken: false,
};

export default PaymentLoading;
